import React, {useState, useEffect} from 'react'
import { IoCopyOutline } from 'react-icons/io5'
import {useAuth} from '../../index'
import axios from 'axios'
import AddDelete from './CBz35lEdhep9brD'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`

export default function TmpDecodeJS() {
  const {auth2FA2, user2, logout} = useAuth()
  const [msg, setMsg] = useState()
  const [userInfo, setUserInfo] = useState(null)
  const [generatedCode1, setGeneratedCode1] = useState('')
  const [generatedCode2, setGeneratedCode2] = useState([])
  useEffect(() => {
    if(userInfo==null){
      const handleSubmit = async (e) => {
        const { data: res } = await axios.post(`${APIURL}/account-info`, {token:window.localStorage.getItem('token')})
        console.log('info:',res)
        if(res.msg==='user info ok'){    
          setUserInfo(res.user)
        }else{
          setMsg(res.msg)
          setTimeout(() => {
            localStorage.removeItem('user')
            localStorage.removeItem('token')
            logout()
          }, 3000)
        }
      }
      setTimeout(handleSubmit, 1)
    }
  })
  const onClick2Copy= (x) =>{
        navigator.clipboard.writeText(x)
  }
  const onClick2Generate1 = () =>{
    setGeneratedCode1(`${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}${Math.random().toString(36).substring(7)}`)

  }
  const onClick2Generate2 = () =>{
  async function getBase64ImageFromUrl(imageUrl) {
  var res = await fetch(imageUrl)
  var blob = await res.blob()
  return new Promise((resolve, reject) => {
    var reader  = new FileReader()
    reader.addEventListener("load", function () {
        resolve(reader.result)
    }, false)
    reader.onerror = () => {
      return reject(this)
    }
    reader.readAsDataURL(blob)
  })
  }
  const items = []
  for(let i=10;i<20;i++){
    const a = Math.random().toString(i).substring(2)
    getBase64ImageFromUrl(`https://placehold.co/200x100?text=LorenIpsum${a}}`)
      .then(x => 
        items.push(x.replace('data:image/svg+xml;base64,','').replaceAll('+','').replaceAll('=','')))
      .catch(err => console.error(err))
  }
  for(let i=10;i<20;i++){
    const a = Math.random().toString(i).substring(2)
    getBase64ImageFromUrl(`https://placehold.co/200x100?text=LorenIpsum${a}}`)
      .then(x => 
        items.push(x.replace('data:image/svg+xml;base64,','').replaceAll('+','').replaceAll('=','')))
      .catch(err => console.error(err))
  }
  for(let i=10;i<20;i++){
    const a = Math.random().toString(i).substring(2)
    getBase64ImageFromUrl(`https://placehold.co/200x100?text=LorenIpsum${a}}`)
      .then(x => 
        items.push(x.replace('data:image/svg+xml;base64,','').replaceAll('+','').replaceAll('=','')))
      .catch(err => console.error(err))
  }
  setGeneratedCode2(items)
}
    return(
      <div className='m-1'>
        <b>Create decode Generator</b><br/>
        <div className='primary-btn w-fit' onClick={onClick2Generate1}>Generate code</div>
        <div className='primary-btn w-fit mt-1' onClick={()=>onClick2Copy(generatedCode1)}>copy</div>
        <div className='border border-indigo-600 wrap-anywhere w-[500px]' style={{wordWrap:'break-word'}}>{generatedCode1}</div>
        <textarea>{generatedCode1}</textarea><br/>
        {generatedCode1.length}
        ok 2. check if code is still working<br/>
        3. Convert img as text <br/>
        <img src='https://placehold.co/200x100?text=LorenIpsum' className='w-[150px]'/>
        <div className='primary-btn w-fit' onClick={()=>onClick2Generate2('https://placehold.co/200x100?text=LorenIpsum')}>Generate code</div>
        {msg}
        {generatedCode2==[]?'':generatedCode2.map(x=><article className='text-wrap max-w-full'>{x}<br/>{x.length}<br/></article>)}<br/><br/>
        1. find ] = useState(<br/>
        2. find 2 key words<br/>
        3. convert to encrypted code for those 2 key words<br/>

        Reset passwordRemove 2FA display<br/>
        Notification of cancellation at displayUnlock code and send code<br/>
        UseEffect > user info to get code<br/>
        Check if code is needed in the pageProduct json has to be <br/>separated by pages<br/>
        Crud page<br/>
        Crud A, crud B codes are required<br/>
        if user purchased add & edit, computer send request for add&edit<br/>
{/* {   
    “Add & Edit”: [  
        {      
            “code_1”: {},      
            “code_2”:{}    
        } 
    ]
} */}
        </div>
    )
}

